export default () => ({
    get soundId() {
        return this.$root.dataset.soundId;
    },

    get audioUrl() {
        return this.$root.dataset.audioUrl;
    },

    get isPlaying() {
        return this.$store.soundPlayer.currentPlayingId === this.soundId;
    },

    togglePlay() {
        if (this.isPlaying) {
            this.pause();
        } else {
            this.play();
        }
    },

    play() {
        if (!this.audioUrl) {
            return;
        }

        // Stop any currently playing sound
        if (window.soundEffect) {
            window.soundEffect.pause();
            window.soundEffect.src = '';
        }

        // Update global state through Alpine store
        this.$store.soundPlayer.setCurrentPlayingId(this.soundId);

        // Create and play new audio
        window.soundEffect = new Audio();
        window.soundEffect.autoplay = true;

        // Play silent audio first (same as original implementation)
        window.soundEffect.src = 'data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV';

        // Then play the actual audio
        window.soundEffect.src = this.audioUrl;

        // Handle audio end
        window.soundEffect.addEventListener('ended', () => {
            this.$store.soundPlayer.setCurrentPlayingId(null);
        });
    },

    pause() {
        if (window.soundEffect) {
            window.soundEffect.pause();
            window.soundEffect.src = '';
        }
        this.$store.soundPlayer.setCurrentPlayingId(null);
    },

    destroy() {
        if (this.isPlaying) {
            this.pause();
        }
    }
})
